<template>
  <div class="common-container">
    <div class="process">
      <div class="title">加盟流程</div>
      <div class="content">
        <div class="c-item" :style="`width:calc(100%/${processList.length})`" v-for="(v,i) in processList" :key="i">
          <el-image :src="v.image"></el-image>
          <div class="ci-title">{{ v.title }}</div>
          <div class="ci-desc">{{ v.desc }}</div>
        </div>
      </div>
    </div>
    <div class="stuff">
      <div class="title">申请所需材料</div>
      <div class="content">
        <div class="c-item" :style="`width:calc(100%/${stuffList.length})`" v-for="(v,i) in stuffList" :key="i">
          <el-image :src="v.image"></el-image>
          <div class="ci-title">{{ v.title }}</div>
        </div>
      </div>
    </div>
    <div class="ask">
      <el-image :src="require('@/assets/joins/ask_bg.png')"></el-image>
      <div class="a-content">
        <div class="title">合作要求</div>
        <div class="content">
          <div class="ac-item" v-for="(v,i) in askList" :key="i">
            <el-image :src="require('@/assets/joins/ask_icon.png')"></el-image>
            <div class="desc">{{ v.desc }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="city">
      <div class="title">合作城市</div>
      <div class="content">
        <china :classify-id="classifyId" :key="classifyId"/>
      </div>
    </div>
    <div class="message-board">
      <div class="title">我要加盟</div>
      <div class="content">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="公司名称:" prop="companyName">
                <el-input v-model="form.companyName" placeholder="请输入公司名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人:" prop="user">
                <el-input v-model="form.user" placeholder="请输入联系人"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="电话:" prop="phone">
                <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="加盟地区:" prop="area">
                <area-select v-model="form.area" placeholder="请选择加盟地区"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item class="btn-item">
            <el-button type="primary" :loading="loading > 0" @click="submit">
              {{ ['立即提交','提交中...','提交成功'][loading]}}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import China from "./components/China.vue";

export default {
  components: {
    China
  },
  name: "Joins",
  data() {
    return {
      classifyId: null,
      processList: [],
      stuffList: [],
      askList: [],
      form: {
        companyName: '',
        user: '',
        phone: '',
        area: []
      },
      rules: {
        companyName: [
          {
            required: true,
            message: '请输入公司名称',
            trigger: 'blur'
          }
        ],
        user: [
          {
            required: true,
            message: '请输入联系人',
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: true,
            message: '请输入电话',
            trigger: 'blur'
          }
        ],
        area: [
          {
            required: true,
            type: 'array',
            message: '请选择加盟地区',
            trigger: 'blur'
          }
        ]
      },
      loading: 0
    }
  },
  watch: {
    '$route.query.classifyId': {
      immediate: true,
      handler(val) {
        if (val) {
          this.classifyId = val
          this.getProcessList(val)
          this.getStuffList(val)
          this.getAskList(val)
        }
      }
    }
  },
  methods: {
    /**
     * 立即提交
     */
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false
        }
        this.loading = 1
        const data = {
          ...this.form,
          classifyId: this.classifyId
        }
        this.$request.post('/Joins/messageBoard', data)
            .then(res => {
              if (res.code === 0) {
                this.form = {
                  companyName: '',
                  user: '',
                  phone: '',
                  area: []
                }
                // this.$message.success(res.message)

                this.$notify({
                  title: '提示信息',
                  dangerouslyUseHTMLString: true,
                  message: `<div style="color: #1e90ff;font-weight: bold;">${res.message}</div>`,
                  type: 'success',
                  position: 'bottom-right'
                });
              }
              this.loading = 2

              setTimeout(() => {
                this.loading = 0
              }, 1000)
            })
            .catch(e => {
              setTimeout(() => {
                this.loading = 0
              }, 1000)
            })
      })
    },
    /**
     * 加盟流程
     */
    getProcessList(classifyId) {
      this.$request.get('/Joins/process', {
        params: {
          classifyId
        }
      }).then(res => {
        if (res.code === 0) {
          this.processList = res.data
        }
      })
    },
    /**
     * 申请所需材料
     */
    getStuffList(classifyId) {
      this.$request.get('/Joins/stuff', {
        params: {
          classifyId
        }
      }).then(res => {
        if (res.code === 0) {
          this.stuffList = res.data
        }
      })
    },
    /**
     * 申请所需材料
     */
    getAskList(classifyId) {
      this.$request.get('/Joins/ask', {
        params: {
          classifyId
        }
      }).then(res => {
        if (res.code === 0) {
          this.askList = res.data
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  color: #2D2D2D;
  font-size: 38px;
  font-weight: bold;
  margin-bottom: 30px;
}

.process {
  background-color: #FFFFFF;
  padding: 30px 0 60px 0;
}

.stuff {
  padding: 80px 0 100px 0;
}

.ask {
  position: relative;
  width: 100%;
  height: 482px;

  .el-image {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }

  .a-content {
    position: absolute;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
    justify-content: center;

    .title {
      color: #FFFFFF;
    }

    .content {
      flex-direction: column !important;
      align-items: flex-start !important;

      .ac-item {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        margin-bottom: 25px;

        &:last-child {
          margin-bottom: 0;
        }

        .el-image {
          position: unset;
          width: 20px;
          height: 16px;
          margin: 3px 15px 0 0;
        }

        .desc {
          font-size: 16px;
          color: #FFFFFF;
          flex: 1;
        }
      }
    }
  }
}

.process, .stuff, .ask .a-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .content {
    width: 1200px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
  }
}

.process, .stuff {
  .content {
    .c-item {
      display: flex;
      flex-direction: column;
      align-items: center;

      .el-image {
        width: 104px;
        height: 104px;
      }

      .ci-title {
        color: #2D2D2D;
        font-size: 20px;
        font-weight: bold;
        margin-top: 5px;
      }

      .ci-desc {
        color: #6C6C6C;
        font-size: 14px;
        text-align: center;
        margin-top: 5px;
        padding: 0 20px;
      }
    }
  }
}

.city {
  width: 100%;
  background-color: #FFFFFF;
  padding: 80px 0 100px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  .content {
    margin-top: 30px;
    width: 1200px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
}

.message-board {
  width: 100%;
  background-color: #FFFFFF;
  padding: 30px 0 100px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  .content {
    margin-top: 30px;
    width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: center;

    ::v-deep {
      .el-form {
        width: 100%;

        .el-form-item__label {
          color: #000000;
          font-size: 14px;
          font-weight: bold;
        }

        .el-input__inner {
          background-color: #F5F6F8;
        }

        .btn-item {
          margin-top: 20px;

          .el-form-item__content {
            margin-left: 0;
            text-align: center;

            .el-button {
              width: 256px;
              background-color: #1464FF;
            }
          }
        }
      }
    }


  }
}
</style>